import PropTypes from "prop-types";

import Img from "components/atoms/Img";
import Title from "components/atoms/Title";

const WalkThrough = ({ data }) => {
  const { walkthrough } = data;

  return (
    <>
      <Title
        className="bbc-title mb-6 text-center capitalize"
        text={data.title}
      />
      {data.description && <p className="mb-6 lg:mb-10">{data.description}</p>}
      {walkthrough.map((item, index) => (
        <div
          key={index}
          className="row mb-6 justify-between last:mb-0 lg:mb-10"
        >
          <div
            className={`${
              item.classNameLeft
                ? item.classNameLeft
                : "col-12 self-center lg:col-6"
            }`}
          >
            {item.title && (
              <Title
                as={`${item.classNameTitle ? "h3" : "h4"}`}
                className={`${
                  item.classNameTitle
                    ? item.classNameTitle
                    : "mb-4 text-left text-lg font-semibold lg:mb-6"
                }   `}
                text={item.title}
              />
            )}
            {item.isList ? (
              <ul className={"mx-0 list-disc pl-5 text-left"}>
                {item.contents.map((content, index) => (
                  <li
                    key={index}
                    className="relative leading-[26px] text-bbc-gray"
                    dangerouslySetInnerHTML={{ __html: content }}
                  />
                ))}
              </ul>
            ) : (
              <div className={"mx-0 list-disc text-left "}>
                {item.contents.map((content, index) => (
                  <p
                    key={index}
                    className="relative mb-6 list-none text-bbc-gray last:mb-0"
                    dangerouslySetInnerHTML={{ __html: content }}
                  />
                ))}
              </div>
            )}
          </div>
          <div
            className={
              (item.classNameRight
                ? item.classNameRight
                : "col-12 order-first mb-6 text-center leading-none lg:col-5 lg:mb-0 ") +
              (item.positionImage === "left"
                ? " lg:order-first"
                : " lg:order-last lg:text-right")
            }
          >
            <Img {...item.img} />
          </div>
        </div>
      ))}
    </>
  );
};

export default WalkThrough;

WalkThrough.propTypes = {
  data: PropTypes.array,
  children: PropTypes.element,
};

WalkThrough.defaultProps = {
  data: [],
  children: <></>,
};
